import { apiError } from "@/lib/api";

// Readable catalog (platform/category) error in the UI language.
export function catalogError(e, tr, fallback) {
  const st = e?.response?.status;
  const detail = apiError(e?.response?.data?.detail);
  if (tr.lang === "fr") return detail || fallback;
  if (st === 409) return detail && detail.startsWith("Le nom anglais") ? "This English name is already used" : "This name already exists";
  if (st === 400) return "Name is required or invalid";
  return fallback;
}
